import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Default as PageIntro } from "../../mytrumpf/partial-templates/page-intro/page-intro.stories";
import { renderPageTemplate, renderStandardPictureElement } from "../../utils";

export default {
    title: "Shared/Knowledge/Faq",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-t-container ux-u-mb-fluid-m">
            ${PageIntro({
                headline:
                    "Häufig gestellte Fragen und Antworten zur Funktion Unternehmensadministrator",
                text: "Mit der neuen MyTRUMPF Funktion Unternehmensadministrator können Rollen mit unterschiedlichen Berechtigungsstufen an Mitarbeiter vergeben werden. So können Sie Ihre unternehmenspezifischen Freigabeprozesse einhalten. Mit der Zuweisung einer Rolle an Benutzer werden die Berechtigungen in MyTRUMPF, dem E-Shop und der Service App geregelt. Zwei Rollen besitzen zudem administrative Rechte, um Rollen an Mitarbeiter zu vergeben bzw. zu ändern oder Kollegen zu MyTRUMPF einzuladen. Nachfolgend stellen wir Ihnen die Rollen mit Ihren Berechtigungen vor und beantworten häufig gestellte Fragen.",
            })}
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Übersicht Rollen und Berechtigungen
                    </h2>
                </div>
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-mb-xs">
                    ${renderStandardPictureElement({
                        width: 1200,
                        height: 600,
                    })}
                    <p class="ux-text-small">
                        * Diese beiden Rollen besitzen administrative
                        Berechtigungen, um Mitarbeitern entsprechende Rollen
                        zuzuweisen und neue Mitarbeiter über einen
                        Einladungslink in MyTRUMPF einzuladen.
                    </p>
                    <p class="ux-text-small">
                        ** Diese Berechtigung wird nicht benötigt, da die Rolle
                        die übergeordnete Berechtigung „Bestellen“ schon
                        besitzt.
                    </p>
                </div>
            </div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Rollen und Berechtigungen in Ihrer Organisation steuern:
                        Fragen und Antworten
                    </h2>
                </div>
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-mb-xs">
                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>

                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>

                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>

                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>
                </div>
            </div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Berechtigungen im E-Shop: Fragen und Antworten
                    </h2>
                </div>
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-mb-xs">
                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>

                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>
                </div>
            </div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Eigene Rolle und Berechtigungen: Fragen und Antworten
                    </h2>
                </div>
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-mb-xs">
                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>

                    <ux-accordion>
                        <span slot="title" class="ux-text-normal">
                            Lorem ipsum dolor sit amet, consetetur sadipscing
                        </span>
                        <p class="ux-u-my-zero">
                            Wenden Sie sich an Ihre lokale Kundenbetreuung.
                            Diese werden Ihnen Ihr Benutzerkonto entsprechend
                            einrichten. Falls es in Ihrem Unternehmen schon
                            Kollegen mit entsprechender Berechtigung gibt, so
                            wenden Sie sich bitte an diese. Die Kollegen können
                            Ihnen ebenfalls die Rolle mit den entsprechenden
                            Berechtigungen zuweisen. Unter "Meine Daten" im
                            Bereich "Übersicht Unternehmensadministratoren"
                            erhalten Sie eine Übersicht über die Kollegen mit
                            entsprechender Berechtigung.
                        </p>
                    </ux-accordion>
                </div>
            </div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero"
                    >
                        Eigene Rolle und Berechtigungen: Fragen und Antworten
                    </h2>
                </div>
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-mb-l">
                    <ux-iws-same-height>
                        <ux-slider
                            pause-on-hover="ux-block-hero__content"
                            loop=""
                            arrows-follow-img=""
                        >
                            <ux-slider-slide label="">
                                <div class="ux-block-hero">
                                    <div class="ux-block-hero__image">
                                        ${renderStandardPictureElement({
                                            width: 1200,
                                            height: 600,
                                        })}
                                    </div>
                                    <p class="ux-text-normal ux-u-my-xxs">
                                        Die oben abgebildeten Rollen sind
                                        aktuell verfügbar und haben
                                        unterschiedliche Berechtigungen. Mit
                                        Klick auf die Rolle können SIe sehen,
                                        welche Berechtigungen einer Rolle
                                        zugewiesen sind.
                                    </p>
                                </div>
                            </ux-slider-slide>
                            <ux-slider-slide label="">
                                <div class="ux-block-hero">
                                    <div class="ux-block-hero__image">
                                        ${renderStandardPictureElement({
                                            width: 1200,
                                            height: 600,
                                        })}
                                    </div>
                                    <p class="ux-text-normal ux-u-my-xxs">
                                        Die oben abgebildeten Rollen sind
                                        aktuell verfügbar und haben
                                        unterschiedliche Berechtigungen. Mit
                                        Klick auf die Rolle können SIe sehen,
                                        welche Berechtigungen einer Rolle
                                        zugewiesen sind.
                                    </p>
                                </div>
                            </ux-slider-slide>
                            <ux-slider-pagination
                                anchor-pagination=""
                                slot="pagination"
                            ></ux-slider-pagination>
                        </ux-slider>
                    </ux-iws-same-height>
                </div>
            </div>
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-my-fluid-xs"
                >
                    <h2
                        class="ux-text-headline ux-text-headline--big ux-u-my-zero ux-u-text-align--center"
                    >
                        Wichtige Hinweise: So vermeiden Sie Verzögerungen bei
                        der Freischaltung und Ersatzteil- bzw.
                        Werkzeugbestellung
                    </h2>
                </div>
                <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1">
                    <p class="ux-text-normal">
                        Nur Benutzer, welche die Rolle Geschäftsführer oder
                        Produktionsleiter zugewiesen haben, können neue Benutzer
                        hinzufügen und freischalten. Das bedeutet, dass während
                        Ihrer Abwesenheiten keine neuen Registrierungen und
                        Freischaltung durch die o.g. Rollen erfolgen können. Es
                        können zudem auch keine Rollen geändert werden, sofern
                        kein Zweiter eine der o.g. Rollen inne hat. Eine
                        selbstständige Registrierung durch Ihre Mitarbeiter mit
                        Freischaltung durch den TRUMPF Innendienst ist dennoch
                        möglich.
                    </p>
                    <p class="ux-text-normal">
                        Bitte beachten Sie jedoch, dass die Standardrolle, die
                        dann vergeben wird, der Servicetechniker ist. Das
                        bedeutet, dass diese Rolle dann auch keine Bestellungen
                        anderer Mitarbeiter Ihrer Organisation freigeben kann.
                        Achten Sie daher unbedingt darauf, dass Sie während
                        Ihrer Abwesenheiten auch Rollen vergeben haben, die
                        Bestellungen auslösen oder freigeben können, wie z.B.
                        den Einkäufer (bestellen und freigeben) und den
                        Servicetechniker (nur bestellen). Die Berechtigungen der
                        jeweiligen Rollen sind oben abgebildet. So vermeiden Sie
                        Verzögerungen in der Ersatzteil- und Werkzeugbestellung.
                    </p>
                </div>
            </div>
        </div>
        <div class="ux-t-container-full">
            <ux-iws-link-wrapper>
                <div class="ux-row ux-u-background-grey">
                    <div
                        class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-mt-l"
                    >
                        <h2
                            class="ux-text-headline ux-text-headline--big ux-u-my-zero ux-u-text-align--center"
                        >
                            Unternehmensadministrator: Das sind die Vorteile
                        </h2>
                    </div>
                    <div
                        class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-u-text-align--center ux-u-mb-l"
                    >
                        <p class="ux-text-normal">
                            Erfahren Sie mehr zur Funktion
                            Unternehmensadministrator und welche Vorteile Ihnen
                            das neue Rollenkonzept bietet.
                        </p>
                        <a
                            class="ux-button ux-u-mt-xxs"
                            href="https://www.trumpf.com/de_DE/mytrumpf/landing-pages-extern/unternehmensadministrator/"
                            >Mehr erfahren</a
                        >
                    </div>
                </div>
            </ux-iws-link-wrapper>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());
